<!-- Mobile Header -->
<header class="mobile-header">
  <h1 class="mobile-logo">SAL<span class="yellow">OO</span>NS</h1>
  <button type="button" class="hamburger-btn" [class.open]="isOpen()" (click)="toggleNav()">
    <span></span>
    <span></span>
    <span></span>
  </button>
</header>

<!-- Overlay for mobile -->
@if (isOpen()) {
<div
  class="nav-overlay"
  (click)="closeNav()"
  (keydown.escape)="closeNav()"
  tabindex="0"
  role="button"
  aria-label="Fermer le menu"
></div>
}

<nav class="dashboard-nav" [class.open]="isOpen()">
  <div class="nav-header">
    <h1>SAL<span class="yellow">OO</span>NS</h1>
    <span class="badge">PRO</span>
  </div>

  <div class="nav-menu">
    @for (item of menuItems; track item.label) {
    <div class="menu-section">
      <button type="button" class="menu-header" (click)="toggleMenu(item)">
        <span class="menu-label">{{ item.label }}</span>
        <svg
          class="chevron"
          [class.expanded]="item.expanded"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </button>

      @if (item.expanded) {
      <div class="submenu">
        @for (child of item.children; track child.route) {
        <button
          type="button"
          class="submenu-item"
          [class.active]="isActive(child.route)"
          (click)="navigate(child.route)"
        >
          {{ child.label }}
        </button>
        }
      </div>
      }
    </div>
    }
  </div>

  <div class="nav-footer">
    <button type="button" class="back-btn" routerLink="/">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <path d="M19 12H5M12 19l-7-7 7-7" />
      </svg>
      Retour à l'app
    </button>
    <button type="button" class="logout-btn" (click)="logout()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
        <polyline points="16 17 21 12 16 7" />
        <line x1="21" y1="12" x2="9" y2="12" />
      </svg>
      Se déconnecter
    </button>
  </div>
</nav>
